import { render, staticRenderFns } from "./ArticleSlidingUpPanel.vue?vue&type=template&id=0a872439&scoped=true&"
import script from "./ArticleSlidingUpPanel.vue?vue&type=script&lang=js&"
export * from "./ArticleSlidingUpPanel.vue?vue&type=script&lang=js&"
import style0 from "./ArticleSlidingUpPanel.vue?vue&type=style&index=0&id=0a872439&scoped=true&lang=css&"
import style1 from "./ArticleSlidingUpPanel.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a872439",
  null
  
)

export default component.exports